import { FPS } from '../constants'
import { CreationToolFrame } from '../types'

type Trim = {
    start: number
    end: number
}

export const getFramesBasedOnTrim = (frames: CreationToolFrame[], trim: Trim) => {
    let editedFrames = [...frames]
    const startFrame = Math.floor(trim.start * FPS)
    const endFrame = Math.floor(trim.end * FPS)
    editedFrames = editedFrames.slice(startFrame, endFrame)
    return editedFrames
}

export default getFramesBasedOnTrim
